<mat-form-field appearance="standard" [ngClass]="jpCustomFormFieldClass">
  <mat-label>{{label}}</mat-label>
  <input matInput (click)="_openDatepickerOnClick(datepicker)" (dateChange)="_dateChangeHandler($event.value)"
    (dateInput)="_dateChangeHandler($event.value)" (keydown.arrowdown)="_openDatepickerOnClick(datepicker)"
    (keydown.enter)="_openDatepickerOnClick(datepicker)" [formControl]="_inputCtrl"
    [matDatepickerFilter]="_customFilter" [matDatepicker]="datepicker" [max]="_max" [min]="_min" readonly>
  <mat-icon class="search-action-icon" (click)="_openDatepickerOnClick(datepicker)" matSuffix>today</mat-icon>
</mat-form-field>
<mat-datepicker #datepicker (closed)="_takeFocusAway(datepicker)" [touchUi]="touchUi">
</mat-datepicker>